// extracted by mini-css-extract-plugin
export default {"coming_soon":"DetailsForDebitCard_coming_soon__PGQT9"};